import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setSection, updateSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import CommonPage from "../../common/CommonPage";
import ComprehensiveBookHead from "../ComprehensiveBookHead";

const OXPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [overlayVisible, setOverlayVisible] = useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
    data: {},
  };

  const buttonList = ["O", "X"];
  const buttonInfo = {
    O: {
      backgroundColor: "#E5FBF8",
      color: "#00A396",
    },
    X: {
      backgroundColor: "#FCEDE9",
      color: "#C2452D",
    },
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }
    setPageList(
      section.question.data.map((question) => {
        return {
          ...question,
          answer: question.answer.split(" ")[0],
          comment: question.answer.split("(")[1].split(")")[0],
          isSubmitted: false,
        };
      })
    );
  }, [section]);

  const clickOX = (OX) => {
    if (currentPage.isSubmitted) return;

    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          input: OX,
          isSubmitted: true,
        };
      } else {
        return page;
      }
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setOverlayVisible(true);
    setTimeout(() => {
      setOverlayVisible(false);
    }, 600);
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
        }
      });

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      paragraph={section?.question.full_text}
      accentColor={typeInfo.comprehensive.color}
      currentPage={currentPage}
      overlayVisible={overlayVisible}
      isCorrect={currentPage.answer === currentPage.input}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "50px",
          width: Math.min(window.innerWidth, window.screen.width) <= 768 ? `${Math.min(window.innerWidth, window.screen.width) - 56}px` : "90%", // [중앙 정렬] 형제 유형과 동일 중앙 열
          maxWidth: "680px",
          margin: "0 auto",
          boxSizing: "border-box",
        }}
      >
        <ComprehensiveBookHead index={currentIndex} total={pageList.length} instruction="본문의 내용과 일치하면 O, 일치하지 않으면 X를 고르세요." />
        <div className="comp-book__question"
          style={{
            fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "18px" : "19px", // [PC 타이포] 발문 위계 정리
            textAlign: "center",
            lineHeight: "1.5",
          }}
        >
          {currentPage.question}
        </div>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "row",
            gap: "30px",
          }}
        >
          {buttonList.map((OX) => {
            return (
              <button
                className="comp-book__ox"
                style={{
                  height: "54px",
                  width: "110px",
                  height: "78px", // [내용이해 PC 리디자인] OX 큰 카드 페어
                  fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "16px" : "24px", // [모바일 폰트]
                  fontWeight: 800,
                  fontFamily: "inherit",
                  cursor: currentPage.isSubmitted ? "default" : "pointer",
                  borderRadius: "14px",
                  backgroundColor: currentPage.isSubmitted
                    ? currentPage.input === OX
                      ? currentPage.answer === OX
                        ? "#00A396"
                        : "#C2452D"
                      : currentPage.answer === OX
                      ? "#00A396"
                      : buttonInfo[OX].backgroundColor
                    : buttonInfo[OX].backgroundColor,
                  color:
                    currentPage.isSubmitted &&
                    (currentPage.input === OX || currentPage.answer === OX)
                      ? "white"
                      : buttonInfo[OX].color,
                  border: currentPage.isSubmitted
                    ? currentPage.input === OX
                      ? currentPage.answer === OX
                        ? "1.5px solid #00A396"
                        : "1.5px solid #C2452D"
                      : currentPage.answer === OX
                      ? "1.5px solid #00A396"
                      : "1.5px solid " + buttonInfo[OX].color
                    : "1.5px solid transparent",
                  boxShadow: currentPage.isSubmitted
                    ? "none"
                    : "0 6px 16px -10px rgba(20, 40, 50, 0.3)",
                  transition: "all 0.2s",
                }}
                onClick={() => clickOX(OX)}
              >
                {OX}
              </button>
            );
          })}
        </div>
      </div>
    </CommonPage>
  );
};

export default OXPage;
